/**
 * @description Foundation Channel Partner nav placeholders (LYN-309)
 *
 * @notes Sales Orgs / Merchants / Integrations are in the nav; not live this ticket.
 */

export default function ChannelPartnerPlaceholder({ title }) {
  return (
    <div className="p-6 max-w-xl">
      <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
      <p className="text-sm text-gray-500 mt-2">This surface is in the foundation nav. It is not this ticket.</p>
    </div>
  );
}
